import {pluck, compose} from 'vitrarius'
import {latestLens, allLens, movementLens, clippingLens, blockedTenantLens} from '../lens/lens'

export const movementLatestTelescope = data => compose(movementLens, latestLens(data))
export const movementAllTelescope = data => compose(movementLens, allLens(data))
export const clippingLatestTelescope = ({provider, data}) => compose(clippingLens, pluck(provider), latestLens(data))
export const clippingAllTelescope = ({provider, data}) => compose(clippingLens, pluck(provider), allLens(data))
export const blockedTenantLatestTelescope = data => compose(blockedTenantLens, latestLens(data))